import { Component, forwardRef, Inject, Input, OnInit, ViewContainerRef } from "@angular/core";
import { TemplateLoaderService } from "../../../dashboard-area/template-loader/template-loader.service";


@Component({
    selector: 'catalog-details-dialog-dynamic-content',
    template: ''
})
export class CatalogDetailsDialogDynamicContentComponent implements OnInit {

    @Input() text: string;

    constructor(
        @Inject(forwardRef(() => ViewContainerRef)) private vcRef: ViewContainerRef,
        @Inject(forwardRef(() => TemplateLoaderService)) private templateLoaderService: TemplateLoaderService
    ) { }

    ngOnInit() {
        this.templateLoaderService.loadFromText(this.text, this.vcRef, true);
    }
}